import { Col, Divider, Row, Typography } from "antd";
import StaticPageBanner from "apps/Common/StaticPageBanner";
import { Helmet } from "react-helmet-async";
const AboutUsIndex = () => {
  const { Text } = Typography;
  return (
    <>
      <Col span={24} className="!overflow-hidden">
        <Row gutter={[0, 20]}>
          <Col xs={24}>
            <StaticPageBanner
              title="Hakkımızda"
              description="Sarı İlanları Daha İyi Tanıyın"
            />
             <Helmet>
                    <title className="capitalize">{"Hakkımızda"}</title>
              </Helmet>
          </Col>
          <Col xs={24}>
            <Row gutter={[20, 20]} className="!px-2 lg:!px-6 xxl:!px-16">
              <Col span={24}>
                <div>
                  <Text className="!text-xl !font-bold">
                    Gayrimenkul ve Araçta Güvenilir Alışverişin Adresi
                  </Text>
                </div>

                <div className="!mt-2">
                  <Text className="!text-xs !text-[#6E7583]">
                    Hayalinizdeki evi ya da aracı arıyorsanız, doğru yerdesiniz!
                    Sarı İlanlar, gayrimenkul ve araç kategorilerinde
                    uzmanlaşmış, hızlı ve güvenilir bir ilan platformudur. 🏠
                    Gayrimenkul: Satılık ve kiralık dairelerden, arsa ve ticari
                    mülklere kadar her bütçeye uygun binlerce ilan bir tık
                    uzağınızda. Doğrudan sahibinden veya güvenilir emlak
                    ofislerinden ilanlara ulaşın. 🚗 Araç: İkinci el ya da sıfır
                    araç mı arıyorsunuz? Araba, motosiklet veya ticari araç
                    ilanlarımızla bütçenize ve ihtiyacınıza en uygun seçeneği
                    kolayca bulun.
                    <div className="bg-yellow-100 p-4 rounded-xl mb-4 !mt-4">
                      <Text className="text-yellow-600 !font-bold">
                        Neden Sarı İlanlar?
                      </Text>
                      <ul className="list-disc pl-5 text-gray-600 !grid gap-2 !mt-2">
                        <li>✔️ Güvenilir ve doğrulanmış ilanlar</li>
                        <li>✔️ Kolay ilan verme ve hızlı arama</li>
                        <li>✔️ Anında güncellenen ilanlarla hızlı sonuç</li>
                        <li>✔️ Doğrudan satıcıyla iletişim imkanı</li>
                      </ul>
                    </div>
                  </Text>
                </div>
              </Col>
              <Col span={24}>
                <Divider className="!m-0" />
              </Col>

              <Col span={24}>
                <div>
                  <Text className="!text-xl !font-bold">Ticaret Unvanı</Text>
                </div>
                <div>
                  <Text className="!text-xs !text-[#6E7583]">
                    SARI İLANLAR BİLGİ TEKNOLOJİLERİ PAZ. VE DIŞ TİCARET A.Ş.
                  </Text>
                </div>
              </Col>
              <Col span={24}>
                <Divider className="!m-0" />
              </Col>

              <Col span={24}>
                <div>
                  <Text className="!text-xl !font-bold">Ticari Sicil No</Text>
                </div>
                <div>
                  <Text className="!text-xs !text-[#6E7583]">705746</Text>
                </div>
              </Col>
              <Col span={24}>
                <Divider className="!m-0" />
              </Col>

              <Col span={24}>
                <div>
                  <Text className="!text-xl !font-bold">Merkez Adres</Text>
                </div>
                <div>
                  <Text className="!text-xs !text-[#6E7583]">
                    AKDENİZ MAH. ŞEHİT FETHİ BEY CAD. HERİS TOWER NO:55/091
                    KONAK/İZMİR
                  </Text>
                </div>
              </Col>
              <Col span={24}>
                <Divider className="!m-0" />
              </Col>

              <Col span={24}>
                <div>
                  <Text className="!text-xl !font-bold">Mersis No</Text>
                </div>
                <div>
                  <Text className="!text-xs !text-[#6E7583]">
                    326027177500011
                  </Text>
                </div>
              </Col>
              <Col span={24}>
                <Divider className="!m-0" />
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    </>
  );
};

export default AboutUsIndex;
